module.exports = __webpack_public_path__ + "img/start_6.95d8ebf1.svg";